export default "<p>edit-user works!</p>\n"